import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import { HealthSystemDALEnumsLocationPosition } from '../api/HealthSystemApi';

interface LocationPositionSelectProps {
  value: number;
  onLocationPositionChange: (value: HealthSystemDALEnumsLocationPosition) => void;
  cssClass?: string;
  fullWidth?: boolean;
  allowAny?: boolean;
  selectId?: string;
}

const LocationPositionSelect = ({
  value,
  onLocationPositionChange: onTypeChange,
  cssClass,
  fullWidth,
  allowAny,
  selectId
}: LocationPositionSelectProps) => {
  const { t } = useTranslation();

  const handleLocationPositionChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const positionValue = event.target.value as HealthSystemDALEnumsLocationPosition;

    //callback
    onTypeChange(positionValue);
  };

  return (
    <FormControl className={cssClass} size="small" fullWidth={fullWidth} variant="outlined">
      <InputLabel id="locationPositionLabel">{t('f-loc-pos')}</InputLabel>
      <Select
        label={t('f-loc-pos')}
        labelId="locationPositionLabel"
        id={selectId || 'locationPositionSelect'}
        value={value}
        onChange={handleLocationPositionChange}
      >
        {allowAny && (
          <MenuItem value={0} id="pos-any">
            {t('f-any')}
          </MenuItem>
        )}
        <MenuItem value={10} id="pos-left">
          {t('f-loc-pos-l')}
        </MenuItem>
        <MenuItem value={20} id="pos-right">
          {t('f-loc-pos-r')}
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default LocationPositionSelect;
